const Information: React.FC = () => {
  return <></>;
};

export default Information;
